import moment from "moment/moment";
import React from "react";

const DetailsInformation = ({
  details,
  payment_amount,
  current_balance,
  total_deposit,
  last_deposit,
  last_payment_date,
  total_claim,
  last_claim_date,
}) => {
  return (
    <div>
      <div className='row'>
        <div className='col-md-10'>
          <div className='row'>
            <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>Policy No: </span>
              <span>{details?.policyAppNumber}</span>
            </div>
            <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>Policy Name: </span>
              <span>{details?.policyName}</span>
            </div>
            <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>Applied By: </span>
              <span>{details?.agentFirstName} {details?.agentLastName}</span>
            </div>
            <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>Status: </span>
              <span className='badge badge-success-lighten'>
                {details?.status === "2" && "Active"}
              </span>
              <span className='badge badge-warning-lighten'>
                {details?.status === "1" && "Pending"}
              </span>
              <span className='badge badge-info-lighten'>
                {(details?.status === "3" || details?.status === undefined) &&
                  "Matured"}
              </span>
              <span className='badge badge-danger-lighten'>
                {(details?.status === "4") && "Terminated"}
              </span>
              <span className='badge badge-danger-lighten'>
                {(details?.status === "5") && "Death"}
              </span>
            </div>
            <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>Sub-Status: </span>
              {parseFloat(details.sumAssured) > parseFloat(payment_amount) &&
                parseFloat(payment_amount) !== 0 && (
                  <>
                    <span className='badge badge-warning-lighten'>
                      Partial payment
                    </span>
                  </>
                )}
              {parseFloat(payment_amount) === 0 && parseFloat(total_claim) === 0 && (
                <>
                  <span className='badge badge-danger-lighten'>
                    No payment yet
                  </span>
                </>
              )}
              {parseFloat(details?.sumAssured) ===
                parseFloat(parseFloat(payment_amount)) && (
                <span className='badge badge-success-lighten'>Fully Paid</span>
              )}
              {/* {parseFloat(details?.sumAssured) < parseFloat(payment_amount) && (
                <>
                  <span className='badge badge-info-lighten'>Overpaid</span>
                </>
              )} */}
            </div>
            <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>Duration: </span>
              <span>{details?.duration} months</span>
            </div>
            {details?.discount && (
              <div className='col-md-6 mt-2'>
                <span className='fw-bold me-2'>Discount: </span>
                <span> {details?.discount}%</span>
              </div>
            )}
            <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>Effective Date: </span>
              <span>{moment(details?.effectiveDate).format("LL")}</span>
            </div>
            <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>End Date: </span>
              <span>{moment(details?.endDate).format("LL")}</span>
            </div>
            <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>Approval Date: </span>
              <span>
                {details?.policy_app_approval_date === "NULL"
                  ? "Policy yet to be approved"
                  : moment(details?.policy_app_approval_date).format("LL")}
              </span>
            </div>
            <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>Sum Assured: </span>
              <span> &#8358;{parseInt(details?.sumAssured)?.toFixed(2)}</span>
            </div>
            <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>Date Created: </span>
              <span>
                {details?.policy_registration_date
                  ? moment(details?.policy_registration_date)?.format("LL")
                  : null}
              </span>
            </div>
            <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>Total Premium: </span>
              <span>
                &#8358;{parseFloat(details?.total_premium)?.toFixed(2)}
              </span>
            </div>
            <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>Current Balance: </span>
              <span>&#8358;{parseFloat(current_balance)?.toFixed(2)}</span>
            </div>
            {/* <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>Total Interest posted: </span>
              <span>
                &#8358;
                {details?.premium_contribution
                  ? parseFloat(details?.premium_contribution)?.toFixed(2)
                  : "0.00"}
              </span>
            </div> */}

            <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>Total Deposit: </span>
              <span>&#8358;{parseFloat(total_deposit)?.toFixed(2)}</span>
            </div>
            <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>Total Claims: </span>
              <span>
                &#8358;
                {total_claim
                  ? parseFloat(total_claim)?.toFixed(2)
                  : "0.00"}
              </span>
            </div>
            <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>Last Deposit: </span>
              <span>
                &#8358;
                {last_deposit ? parseFloat(last_deposit).toFixed(2) : "0.00"}
              </span>
              {last_payment_date && (
                <span> @ {moment(last_payment_date).format("LL")}</span>
              )}
            </div>
            <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>Last Claim: </span>
              <span>
                &#8358;
                {total_claim
                  ? parseFloat(total_claim)?.toFixed(2)
                  : "0.00"}
              </span>
              {last_claim_date && (
                <span> @ {moment(last_claim_date).format("LL")}</span>
              )}
            </div>
            <div className='col-md-6 mt-2'>
              <span className='fw-bold me-2'>Interest Rate: </span>
              <span>
                {details?.interest_rate
                  && `${details?.interest_rate}%`}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsInformation;
